// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"6a419d7d","67":"aa41574a","375":"165af66d","532":"7906e33b","787":"e2d1493d"}[chunkId] + ".chunk.js";
};